import { render } from "./BusinessunitSelection.vue?vue&type=template&id=10aaed63"
import script from "./BusinessunitSelection.vue?vue&type=script&lang=js"
export * from "./BusinessunitSelection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__